import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpResponse  } from '@angular/common/http';
import { timeout } from 'rxjs/operators';
import { environment } from '../../../environments/environment';

@Injectable({
  providedIn: 'root',
})
export class CopyService {
  model = 'RPMCopy';
  constructor(private httpClient: HttpClient) {}
  async performCopy(data, entityType, entityID): Promise<HttpResponse<string>> {
     const headerValues = new HttpHeaders({ 'Content-Type': 'application/*+json' });     
     headerValues.append('Content-Type', 'application/*+json');
      
    return this.httpClient
      .post(`${this.model}?EntityType=${entityType}&EntityID=${entityID}`, data, { headers: headerValues, responseType: 'text', observe: 'response' })
      .pipe(timeout(environment.requestTimeout))
      .toPromise() as Promise<HttpResponse<string>>;
  }  
}
